import '@babel/polyfill';
import Vue from 'vue';
import './plugins/vuetify';
import Vuex from 'vuex';
import App from './App.vue';
import VueRouter from 'vue-router';
import routes from './routes';
import translateModule from './common/store/translate';
import errorModule from './common/store/error';
import successModule from './common/store/success';
import breadcrumbModule from './common/store/breadcrumb';
import authModule from './users/store/auth';
import usersModule from './users/store/users';
import usersAuthorizationModule from './authorization/store/users';
import { AUTHORIZATION } from './constants';
import axios from 'axios';
import { translater } from './tools/translate';
import routesModule from './routes/store/routes';
import locationsModule from './routes/store/locations';
import linesModule from './routes/store/lines';
import drawerModule from './routes/store/drawer';
import checkpointsModule from './routes/store/checkpoints';
import filesModule from './files/store/files';
import checkpointsValidatorModule from './routes/store/validators/checkpoints';
import routesValidatorModule from './routes/store/validators/routes';
import statsModule from './stats/store/stats';
import statusModule from './status/store/status';
//import importerModule from './common/store/importer';
import settingsModule from './common/store/settings';
import VueImpress from 'vue-impress';
import VueScrollTo from 'vue-scrollto';

Vue.config.productionTip = false;

/* CUSTOM SETTINGS BEGIN */

window.vm = new Vue();

Vue.use(VueImpress);
Vue.use(VueRouter);
Vue.use(Vuex);
Vue.use(VueScrollTo);

let lang = 'en';
let langInLocalStorage = localStorage.getItem('lang');

let langFound = ['en', 'fi', 'zh'].find(l => {
  return l == langInLocalStorage;
});

if (langFound) {
  lang = langFound;
}

// custom request interceptor injecting authorization token to every request
axios.interceptors.request.use(config => {
  if (localStorage.getItem(AUTHORIZATION)) {
    config.headers[AUTHORIZATION] = localStorage.getItem(AUTHORIZATION);
  }

  if (localStorage.getItem('remoteauthorization')) {
    config.headers['remoteauthorization'] = localStorage.getItem(
      'remoteauthorization'
    );
  }

  config.headers['lang'] = lang;

  return config;
});

const router = new VueRouter({
  routes: routes
});

//export const eb = new Vue();

export const store = new Vuex.Store({
  modules: {
    translate: translateModule,
    auth: authModule,
    error: errorModule,
    success: successModule,
    users: usersModule,
    usersAuthorization: usersAuthorizationModule,
    routes: routesModule,
    locations: locationsModule,
    lines: linesModule,
    breadcrumbs: breadcrumbModule,
    drawer: drawerModule,
    checkpoints: checkpointsModule,
    checkpointsValidator: checkpointsValidatorModule,
    routesValidator: routesValidatorModule,
    files: filesModule,
    stats: statsModule,
    status: statusModule,
    //importer: importerModule,
    settings: settingsModule
  }
});

router.onError(e => {
  store.dispatch('error/setError', translater.__(e.message, 'error'));
  setTimeout(() => {
    store.dispatch('error/setError', undefined);
  }, 5000);
});

new Vue({
  render: h => h(App),
  router: router,
  store: store
}).$mount('#app');
